import type { User } from '@supabase/supabase-js'

/* Intercom est injecte globalement par index.html (script tiers, pas de
   typing officiel). Pas de bulle pour l'equipe Cinqo (@cinqo.fr) dans
   l'interface admin : elle recouvrait des boutons sur mobile. L'equipe la
   retrouve en « Se connecter en tant que » (cf ImpersonationPanel). */

export function isCinqoStaff(user: User): boolean {
  return (user.email?.toLowerCase() ?? '').endsWith('@cinqo.fr')
}

export function bootIntercom(user: User) {
  if (typeof window === 'undefined' || !(window as any).Intercom) return
  ;(window as any).Intercom('boot', {
    app_id: 'epr1bo86',
    email: user.email,
    name: user.user_metadata?.full_name ?? user.email,
    created_at: Math.floor(new Date(user.created_at).getTime() / 1000),
  })
}

export function shutdownIntercom() {
  if (typeof window === 'undefined' || !(window as any).Intercom) return
  ;(window as any).Intercom('shutdown')
}
